import { truncateString } from '@utils/functions';
import classes from './ConfirmationModal.module.css';
import WarningIcon from '@assets/icons/warning.svg';

import {
	Modal,
	Button,
	Group,
	Text,
	Box,
	Image,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';

export const ConfirmationModal = (props: {
	onConfirm: () => void;
	onClose: () => void;
	title: string;
	description: string;
	opened: boolean;
}) => {
	const { t } = useTranslation();

	return (
		<Modal
			opened={props.opened}
			onClose={props.onClose}
			classNames={classes}
			withCloseButton={false}
			size={500}
			zIndex={9999}
		>
			<Image
				className={classes.iconWarning}
				src={WarningIcon}
			/>
			<Box className={classes.spacer} />
			<Text className={classes.title}>
				{truncateString(props.title, 87)}
			</Text>
			<Box className={classes.spacer} />
			<Box
				style={{
					display: 'flex',
					height: '60px',
				}}
			>
				<Text className={classes.description}>
					{truncateString(props.description, 120)}
				</Text>
			</Box>

			<Group mt="xl">
				<Button
					size="md"
					color="gray"
					variant="transparent"
					data-testid="MODk61R0_ZHjdHi6C-button"
					onClick={() => {
						props.onClose();
					}}
					className={classes.cancel}
				>
					{t('global.cancel')}
				</Button>
				<Button
					data-testid="MODk61R0_ZHjdHi6D-button"
					className={classes.button}
					size="md"
					color="orange"
					onClick={() => {
						props.onConfirm();
					}}
				>
					{t('global.iConfirm')}
				</Button>
			</Group>
		</Modal>
	);
};
